export enum ClanInvitationStatus
{
  Pending = 0,
  Diclined = 1,
  Accepted = 2,
}
